import { render, staticRenderFns } from "./TotalCharge.vue?vue&type=template&id=c8f6b1ac&scoped=true"
import script from "./TotalCharge.vue?vue&type=script&lang=js"
export * from "./TotalCharge.vue?vue&type=script&lang=js"
import style0 from "./TotalCharge.vue?vue&type=style&index=0&id=c8f6b1ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f6b1ac",
  null
  
)

export default component.exports